import { render } from "./FormSelect.vue?vue&type=template&id=e9e38ffa"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QIcon,QItem,QItemSection,QCheckbox,QItemLabel});
